import { PropsWithChildren } from "react";

import { ZodProvider } from "@autoform/zod";
import _ from "lodash";

import { LoadingButton } from "@/components/common/loading-button";
import { AutoForm } from "@/components/ui/autoform";
import { injectCustomAutoFormComponents } from "@/components/ui/autoform/components/custom";
import GenresField from "@/components/ui/autoform/components/custom/GenresField";
import { Button } from "@/components/ui/button";
import { LineupFormField } from "@/pages/events/components/fields/lineup-field";
import { MapsUrlField } from "@/pages/events/components/fields/maps-url-field";
import { VenueSelectField } from "@/pages/events/components/fields/venue-select-field";
import { VenueTbaField } from "@/pages/events/components/fields/venue-tba-field";
import { useEventCreateForm } from "@/pages/events/create/hooks/use-event-create-form";
import { basicEventSubmitSchema } from "@/pages/events/schemas/event.create.form";

interface EventCreateBasicInfoProps {}

const schemaProvider = new ZodProvider(basicEventSubmitSchema);

export const EventCreateBasicInfo = ({
  children,
}: PropsWithChildren<EventCreateBasicInfoProps>) => {
  const { id, basicInfoStep, loading, onBasicInfoStepSubmit, methods } =
    useEventCreateForm();

  return (
    <div className="flex flex-col gap-2">
      <AutoForm
        key={JSON.stringify(basicInfoStep)}
        schema={schemaProvider}
        defaultValues={basicInfoStep}
        onSubmit={onBasicInfoStepSubmit}
        {...injectCustomAutoFormComponents({
          formComponents: {
            lineup: LineupFormField,
            genres: GenresField,
            mapsUrl: MapsUrlField,
            venue: VenueSelectField,
            venueTba: VenueTbaField,
          },
        })}
      >
        <div className="flex justify-end space-x-2">
          {id && (
            <Button
              type="button"
              disabled={loading.basicInfo === "loading"}
              onClick={() => methods.next()}
            >
              Next
            </Button>
          )}
          <LoadingButton isLoading={loading.basicInfo === "loading"}>
            {id ? `Update & Continue` : `Save & Continue`}
          </LoadingButton>
        </div>
      </AutoForm>
    </div>
  );
};
